import React from 'react'

import { PaddingBottomProps } from 'styled-system'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { HomePageQuery } from 'GraphQL/DatoCMS/TypedDocuments'

import Scroller from './Scroller'
import { Container } from './styles'

type Props = PaddingBottomProps & {
  data?: HomePageQuery
}

function OurPlatinumMembersSection({ data, ...rest }: Props) {
  if (!data) return null

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container {...rest} px={LANDING_CONTENT_PX}>
          <SubsectionTitle centered title="Our Platinum Members" />

          <Scroller data={data} />
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default OurPlatinumMembersSection
